import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Http } from '@angular/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { constant } from 'app/app.constants';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { Observable } from 'rxjs/Observable';
import { IMovement } from 'app/pages/billing-general/billed/billed-interface';

@Injectable()
export class BillingScheduleService extends ParentService {

  private formData = new BehaviorSubject<IMovement>(null);
  formData$ = this.formData.asObservable();

  @Output() modalClosed: EventEmitter<boolean> = new EventEmitter();
  @Output() eventSave: EventEmitter<boolean> = new EventEmitter();

  constructor(private http: Http) {
    super();
  }

  getFormData(data) {
    this.formData.next(data);
  }

  getBillingSchedule() {
    return this.http.get(constant.URL_BILLING_SCHEDULE_LIST, this.getHeader())
      .map((Response) => Response.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getPayorReasonForTransport(payorid) {
    const url = `${constant.URL_REASON_TRANSPORT_LIST}/${payorid}`;
    return this.http.get(url, this.getHeader())
      .map(resp => resp.json())
      .catch(error => Observable.throw(error.json()));
  }

  getPayorsAll() {
    return this.http.get(`${constant.URL_PAYOR_LIST}`, this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  postDataSchedule(data) {
    return this.http.post(constant.URL_MASS_MOVEMENT_BILLING, data, this.headerPost())
      .map(res => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/billing-scheduled-edit/billing-schedule.service.ts